import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageTextLock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPageTextLock"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22H11.5V14.75H12.7204C13.2969 13.0074 14.9391 11.75 16.875 11.75C18.0992 11.75 19.2059 12.2528 20 13.0631V2H4ZM7 5V6.5H15V5H7ZM7 9V10.5H12V9H7Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 16H21V22H13V16H14C14 14.3431 15.3431 13 17 13C18.6569 13 20 14.3431 20 16ZM18.5 16C18.5 15.1716 17.8284 14.5 17 14.5C16.1716 14.5 15.5 15.1716 15.5 16H18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageTextLock;
